// times tables math - functions

export function genorateTable(ttNumber:number):string[] {
	var ttarray = [];
	for (let i = 2; i < 13; i++) {
		//we exclude multiplication by 10
		if (i != 10) {
			ttarray.push(ttNumber +'x'+ i + '=' + i * ttNumber);
		}
	}

	return ttarray;
}

export function genorateTables(from:number, to:number):string[] {
	/*var ttsarray = [];
	for (let i = from; i < to+1; i++) {
		ttsarray.push(genorateTable(i));
		
	}*/
	var ttsarray = [];
	for (let i = from; i < to+1; i++) {
		//we exclud time tables for 10
		if (i != 10) {
			var arr = genorateTable(i);
			for (let i = 0; i < arr.length; i++) {
				ttsarray.push(arr[i]);
				
			}
		}
		
	}
	return ttsarray;
}

export function genorateExcersices(from:number, to:number, excersicesCount:number):string[]{
	var arr = [];

	var uniqueExcersices = genorateTables(from, to);
	for (let i = 0; i < excersicesCount; i++) {
		arr.push(uniqueExcersices[Math.floor(Math.random() * uniqueExcersices.length)]);//randomly selceting excersices from uniqueExcersices.
		
	}

	return arr;
}